<template>
  <auth-layout pageClass="change-password-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <form action="change-password">
          <!--You can specify transitions on initial render. The `card-hidden` class will be present initially and then it will be removed-->
          <fade-render-transition>
            <card>
              <br>
              <div slot="header">
                <h3 class="card-title text-center">Choose a new Password</h3>
              </div>
              <div>
                <fg-input label="New Password"
                          placeholder="password"
                          type="password"
                          v-model="model.password"
                          @keyup.enter="submit">

                </fg-input>
                <fg-input label="Repeat password"
                          type="password"
                          placeholder="password"
                          v-model="model.password2"
                          @keyup.enter="submit">
                </fg-input>
                <!-- <fg-input>
                  <l-checkbox v-model="model.subscribe">
                    Subscribe to newsletter
                  </l-checkbox>
                </fg-input> -->
              </div>
              <br>
              <div :style="{color: 'red', }" class="ml-auto"> {{serverResponse}} </div>
              <br>
              <div class="text-center">
                <button type="button" @click="submit" class="btn btn-fill btn-info btn-round btn-wd ">Submit</button>
                <br><br>
              </div>
            </card>
          </fade-render-transition>

        </form>
      </div>
    </div>
  </auth-layout>
</template>
<script>
  import { Checkbox as LCheckbox, FadeRenderTransition } from 'src/components/index'
  import AuthLayout from './AuthLayout.vue'
  export default {
    components: {
      LCheckbox,
      FadeRenderTransition,
      AuthLayout,
    },
    data () {
      return {
        model: {
          password: '',
          password2: ''
        },
        serverResponse: '',
      }
    },
    methods: {
      // toggleNavbar () {
      //   document.body.classList.toggle('nav-open')
      // },
      // closeMenu () {
      //   document.body.classList.remove('nav-open')
      //   document.body.classList.remove('off-canvas-sidebar')
      // },
      async submit () {
        try {
          this.serverResponse = ''
          const passwordFormat = 'Password must be at least 8 characters long, ' +
                                     'contain at least 1 lower case letter, ' +
                                     '1 upper case letter, 1 number ' +
                                     ' and 1 special characeter !&%?+=-'
          if (this.model.password == this.model.password2) {
            if (this.model.password.length < 8
            || !/.*[a-z]+.*/g.exec(this.model.password)
            || !/.*[A-Z]+.*/g.exec(this.model.password)
            || !/.*[0-9]+.*/g.exec(this.model.password)
            || !/.*[\!\%\&\?\+\-]+.*/g.exec(this.model.password)
            ) {
              this.serverResponse = passwordFormat
              return
            }
            this.serverResponse = ''
            var response = await this.$store.dispatch('changePassword', this.model.password)
            this.$notify({successMessage: `Password changed!`})

            if (response && response.errors) {
              this.serverResponse = response.errors.reduce((accumulator, currentValue) => accumulator + '; ' + currentValue)
            }
          }
          else {
            this.serverResponse = `The 2 passwords don't match`
            this.model.password = ''
            this.model.password2 = ''
            setTimeout(()=>this.serverResponse = '', 4000)
          }
        }
        catch (error) {
          console.log('login(): error:', error)
        }
      }
    },
    // beforeDestroy () {
    //   this.closeMenu()
    // }
  }
</script>
<style>
  .navbar-nav .nav-item p{
    line-height: inherit;
    margin-left: 5px;
  }
</style>
